import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CashSessionEventService {
  private readonly _sessionChanged$ = new Subject<void>();
  readonly sessionChanged$ = this._sessionChanged$.asObservable();

  notifyChanged(): void {
    this._sessionChanged$.next();
  }
}
